export const padDateTimePart = (value) => String(value).padStart(2, "0");

export const DATE_TIME_FIELD_HOURS = Object.freeze(Array.from({ length: 24 }, (_, index) => index));
export const DATE_TIME_FIELD_MINUTES = Object.freeze(Array.from({ length: 60 }, (_, index) => index));

export const buildDateTimePartsFromDate = (date) => ({
  year: date.getFullYear(),
  month: date.getMonth() + 1,
  day: date.getDate(),
  hour: date.getHours(),
  minute: date.getMinutes(),
});

export const defaultDateTimeFieldParts = () => buildDateTimePartsFromDate(new Date());

export const buildDateFromDateTimeParts = (parts) => {
  if (!parts) return null;
  const date = new Date(parts.year, parts.month - 1, parts.day, parts.hour || 0, parts.minute || 0);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const parseDateTimeFieldParts = (value) => {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : buildDateTimePartsFromDate(value);
  }

  const normalized = String(value || "").trim();
  if (!normalized) return null;

  const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::\d{2})?)?/);
  if (match) {
    const parts = {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
      hour: Number(match[4] || "0"),
      minute: Number(match[5] || "0"),
    };
    const date = buildDateFromDateTimeParts(parts);
    if (
      date
      && date.getFullYear() === parts.year
      && date.getMonth() + 1 === parts.month
      && date.getDate() === parts.day
      && date.getHours() === parts.hour
      && date.getMinutes() === parts.minute
    ) {
      return parts;
    }
    return null;
  }

  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : buildDateTimePartsFromDate(parsed);
};

export const formatDateTimeFieldValue = (parts) => {
  if (!parts) return "";
  return `${String(parts.year).padStart(4, "0")}-${padDateTimePart(parts.month)}-${padDateTimePart(parts.day)}T${padDateTimePart(parts.hour)}:${padDateTimePart(parts.minute)}`;
};

export const formatDateTimeFieldDisplay = (parts) => {
  if (!parts) return "";
  return `${padDateTimePart(parts.day)}.${padDateTimePart(parts.month)}.${String(parts.year).padStart(4, "0")}, ${padDateTimePart(parts.hour)}:${padDateTimePart(parts.minute)}`;
};
